import {SelectChangeEvent} from '@mui/material';
import React from 'react';
import LFCSelectForm from '_components/inputs/LFCSelectForm';
import {useTranslation} from 'react-i18next';

interface Props {
  name: string;
  label?: string;
  value: any;
  onChange: ((event: SelectChangeEvent<any>, child: React.ReactNode) => void) | undefined;
  style?: any;
  fullWidth?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  margin?: 'dense' | 'normal' | 'none';
  required?: boolean;
  size?: 'small' | 'medium';
  multiple?: boolean;
}

/**
 * 機種プルダウン
 * @param props
 * @returns
 */
const LFCSelectFormSpliceCode = React.memo((props: Props) => {
  const {t} = useTranslation();
  const items: {name: string; value?: number}[] = [
    {name: t('すべて'), value: 9},
    {name: t('BOTH SIDE（両引き）'), value: 1},
    {name: t('HALF（半引き）'), value: 2},
    {name: t('ONE SIDE（片引き）'), value: 3},
    {name: t('突き合わせ'), value: 4}
  ];

  return (
    <LFCSelectForm
      name={props.name}
      label={props.label ? props.label : t('継手')}
      value={props.value != null ? props.value : 9}
      onChange={props.onChange}
      style={props.style}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      autoFocus={props.autoFocus}
      margin={props.margin}
      required={props.required}
      size={props.size}
      multiple={props.multiple}
      selectItem={items}
      id={'splicecode'}
    />
  );
});
export default LFCSelectFormSpliceCode;
